// extracted by mini-css-extract-plugin
export var banner = "banner-PJ1";
export var close_icon = "close_icon-4Pv";
export var container = "container-w0u";